module.exports = __webpack_public_path__ + "img/4.7611824e.jpg";